import en from '@/app/translations/locales/en/translations.json';
import es from '@/app/translations/locales/es/translations.json';

export const translationsVariables = {
    companyName: 'Triumph',
    siteName: 'Triumph Originations',
    siteUrl: 'FaaSByDelta.com',
};

export const getTranslationsResources = () => ({
    en,
    es,
});
